import React, { useEffect, useState } from "react";

/* ================================================================
   Nexus One bottom status bar — glassy, fixed at the bottom of /app/*
   Left  : Nexus One A-mark + tagline
   Right : 4 pills — System / Security / Uptime / Next Briefing
   ================================================================ */

function useNow(intervalMs = 60_000) {
    const [now, setNow] = useState(new Date());
    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(t);
    }, [intervalMs]);
    return now;
}

function nextBriefingLabel(now) {
    // Next briefing every day at 08:00 local
    const next = new Date(now);
    next.setHours(8, 0, 0, 0);
    if (next <= now) next.setDate(next.getDate() + 1);
    const diffMin = Math.round((next - now) / 60_000);
    if (diffMin < 60) return `in ${diffMin}m`;
    const hrs = Math.floor(diffMin / 60);
    return `in ${hrs}h ${diffMin - hrs * 60}m`;
}

function StatusPill({ label, value, dotColor, testid }) {
    return (
        <span
            className="inline-flex items-center gap-1.5 rounded-full px-2.5 h-6 text-[10.5px] font-medium"
            style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid var(--atlas-border-strong)",
                color: "var(--atlas-text-secondary)",
            }}
            data-testid={testid}
        >
            <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ background: dotColor, boxShadow: `0 0 6px ${dotColor}` }}
            />
            <span style={{ color: "var(--atlas-text-muted)" }}>{label}</span>
            <span style={{ color: "var(--atlas-text-primary)" }} className="tabular-nums">{value}</span>
        </span>
    );
}

export default function AtlasStatusBar() {
    const now = useNow();
    return (
        <footer
            className="h-9 flex-shrink-0 flex items-center justify-between px-6 relative z-10"
            style={{
                background: "rgba(10, 10, 26, 0.82)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                borderTop: "1px solid rgba(139, 92, 246, 0.14)",
            }}
            data-testid="atlas-status-bar"
        >
            <div className="flex items-center gap-2 min-w-0">
                <span
                    className="atlas-logo-mark text-[9.5px] leading-none"
                    style={{ padding: "3px 5px", fontSize: 10 }}
                >
                    A
                </span>
                <span
                    className="text-[10.5px] font-medium truncate"
                    style={{ color: "var(--atlas-text-muted)", letterSpacing: "0.01em" }}
                >
                    Your intelligence. Amplified.
                </span>
            </div>
            <div className="flex items-center gap-2 flex-wrap justify-end">
                <StatusPill label="System"    value="Nominal"     dotColor="#10b981" testid="status-system" />
                <StatusPill label="Security"  value="Sealed"      dotColor="#8b5cf6" testid="status-security" />
                <StatusPill label="Uptime"    value="99.98%"      dotColor="#06b6d4" testid="status-uptime" />
                <StatusPill label="Briefing"  value={nextBriefingLabel(now)} dotColor="#f59e0b" testid="status-briefing" />
            </div>
        </footer>
    );
}
